export default __webpack_public_path__ + "static/media/borys.dd545a15.png";